import axios from 'axios'
import { showToast, showFailToast } from 'vant'

// 创建axios实例
const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // 这个需要改为 '/'
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    console.log('发起请求:', config.method?.toUpperCase(), config.url, config.data)
    
    // // 添加认证token（如果有）
    // const token = localStorage.getItem('auth_token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    
    return config
  },
  (error) => {
    console.error('请求拦截器错误:', error)
    return Promise.reject(error)
  }
)
// 响应拦截器
request.interceptors.response.use(
  (response) => {
    console.log('请求响应:', response.config.url, response.data)
    
    const res = response.data
    
    // 检查业务错误码
    if (res.code !== 0 && res.code !== undefined) {
      console.error('业务错误:', res.code, res.message)
      
      // 使用延迟确保不会被其他toast覆盖
      setTimeout(() => {
        const userMessage = getBusinessErrorMessage(res.code, res.message)
        showFailToast(userMessage)
      }, 100)
      
      return Promise.reject(new Error(res.message || '业务错误'))
    }
    
    return res
  },
  (error) => {
    console.error('请求错误:', error)
    
    let message = '网络错误，请稍后重试'
        // 处理连接拒绝错误（后端未启动）
    if (error.code === 'ECONNREFUSED' || error.message.includes('ECONNREFUSED')) {
      message = '后端服务未启动，请检查服务状态'
    }
    // 处理网络错误
    else if (error.message === 'Network Error') {
      message = '网络连接失败，请检查网络连接'
    }
    // 处理超时错误
    else if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
      message = '请求超时，请检查网络连接或稍后重试'
    }
    // 处理代理错误
    else if (error.message.includes('Proxy error') || error.message.includes('ENOTFOUND')) {
      message = '服务连接失败，请确保后端服务正在运行'
    }
    else if (error.response) {
      console.error('响应错误:', error.response.status, error.response.data)
      
      const backendData = error.response.data
      if (backendData && backendData.code !== undefined) {
        setTimeout(() => {
          const userMessage = getBusinessErrorMessage(backendData.code, backendData.message)
          showFailToast(userMessage)
        }, 100)
        return Promise.reject(new Error(backendData.message))
      }
      
      // HTTP错误处理
      switch (error.response.status) {
        case 400:
          message = '请求参数错误'
          break
        case 401:
          message = '未授权，请重新登录'
          break
        case 403:
          message = '拒绝访问'
          break
        case 404:
          message = '请求地址不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        case 502:
          message = '网关错误'
          break
        case 503:
          message = '服务不可用'
          break
        default:
          message = `网络错误: ${error.response.status}`
      }
    } else if (error.request) {
      console.error('无响应错误:', error.request)
      message = '网络连接异常，请检查网络'
    } else {
      console.error('其他错误:', error.message)
      message = error.message
    }
    
    // 延迟显示错误提示
    setTimeout(() => {
      showFailToast(message)
    }, 100)
    
    return Promise.reject(error)
  }
)

// 业务错误码映射到用户友好的提示信息
function getBusinessErrorMessage(code, defaultMessage) {
  const messageMap = {
    1001: '订单不存在，请检查订单号',
    1002: '订单状态异常，无法进行此操作',
    1003: '支付失败，请稍后重试',
    1004: '签名验证失败',
    1005: '创建订单失败',
    1006: '发起支付失败，请检查支付参数',
    
    // 可以添加更多业务错误码的映射
    400: '请求参数不正确',
    401: '请先登录',
    403: '没有权限执行此操作',
    404: '请求的资源不存在',
    500: '系统繁忙，请稍后重试'
  }
  
  return messageMap[code] || defaultMessage || '操作失败，请稍后重试'
}

export default request